export default "__VITE_ASSET__DTt$vctC__"